import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGUAGES } from "../i18n/translations";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" && localStorage.getItem("signapharma_lang");
    return saved && translations[saved] ? saved : "fr";
  });

  useEffect(() => {
    localStorage.setItem("signapharma_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang] || translations.fr;

  return (
    <I18nContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
